import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
// Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import { ToastMsg } from "./TostMsg";
import { PostCallWithErrorResponse, simpleGetCallWithErrorResponse } from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";

const RamzanSection = () => {
  const { sidebar } = useContext(AppContext);

  const [isOn, setIsOn] = useState(false);
  const [r_loader, setr_loader] = useState(true);

  // Load Ramzan section status
  useEffect(() => {
    setting_listing();
  }, []);

  const setting_listing = () => {
    simpleGetCallWithErrorResponse(ApiConfig.RAMZANSECTION)
      .then((res) => {
        setr_loader(false);
        const value = res.json?.data?.ramzan_section;
        setIsOn(!!value); // ensures boolean value
      })
      .catch((err) => {
        setr_loader(false);
        ToastMsg("error", "Something went wrong while fetching data.");
      });
  };

  const toggle = () => {
    const nextState = !isOn;
    setIsOn(nextState);
    updateRamzanSection(nextState);
  };

  const updateRamzanSection = async (nextState) => {
    const requestBody = JSON.stringify({
      ramzan: nextState,
    })

    await PostCallWithErrorResponse(ApiConfig.RAMZANSECTION_UPDATE, requestBody)
      .then((resp) => {
        if (resp.json.success === true) {
          ToastMsg("success", resp.json.message);
          setting_listing()
        } else {
          ToastMsg("error", resp.json.message);
        }
      })
      .catch((err) => {
        ToastMsg("error", "Error while updating Ramzan section.");
        console.error("Update error:", err);
      });
  };

  return (
    <main
      id="cx-main"
      className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
      <div className="wrapper-push-notification">
        <div className="col-md-12 right-section">
          <h4>Ramzan Section</h4>

          <div className="mt-5">
            <div className="row jd-main">
              <div className="table-wrapper mt-4">
                <table className="display table table-lg table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th style={{ textAlign: "left" }}>Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td style={{ textAlign: "left" }}>Ramzan Section</td>
                      <td className="action">
                        <button 
                        style={{
                          height:"40px",
                          width:"80px"
                        }}
                          onClick={toggle}
                          className={`px-4 py-2 text-white font-bold rounded-lg shadow-md transition-all ${
                            isOn ? "bg-green-500" : "bg-gray-500"
                          }`}
                        >
                          {isOn ? "ON" : "OFF"}
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default RamzanSection;
